import { timeOutPromiseFunction } from '../../@types/helpers/debounceFunction';

export const timeOutPromise: timeOutPromiseFunction = (func, timeout) => {
  return new Promise(resolve => {
    setTimeout(() => {
      func();
      resolve('done');
    }, timeout);
  });
};
